import './assets/item.css';
import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { faCheck as d } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as l } from "@fortawesome/react-fontawesome";
import * as e from "@radix-ui/react-select";
import p from "clsx";
import { forwardRef as f } from "react";
const _ = "_item_9p8en_1", I = "_indicator_icon_9p8en_33", t = {
  item: _,
  indicator_icon: I
}, h = f((i, r) => {
  const { children: c, className: m, disabled: n, ...s } = i;
  return /* @__PURE__ */ a(
    e.Item,
    {
      className: p(t.item, m),
      disabled: n,
      ...s,
      ref: r,
      children: [
        /* @__PURE__ */ o(e.ItemIndicator, { className: t.indicator_icon, children: /* @__PURE__ */ o(l, { icon: d }) }),
        /* @__PURE__ */ o(e.ItemText, { children: /* @__PURE__ */ o("span", { children: c }) })
      ]
    }
  );
});
h.displayName = "Item";
export {
  h as Item
};
